export const STOCK_TYPES = [
    // eslint-disable-next-line max-len
    { key: 'in_stock', label: 'In Stock' }, { key: 're_order', label: 'Re-order' }, { key: 'pre_order', label: 'Pre-order' },
];
